const STORAGE_KEY = 'paykit_setups_completed'
const BASE_COUNT = 847
const CHANNEL_NAME = 'paykit_setups_sync'

function getCount(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const val = parseInt(stored, 10)
      if (!isNaN(val) && val >= BASE_COUNT) return val
    }
  } catch {}
  return BASE_COUNT
}

function incrementCount(): number {
  const current = getCount() + 1
  try {
    localStorage.setItem(STORAGE_KEY, String(current))
    // Notify other tabs
    const bc = new BroadcastChannel(CHANNEL_NAME)
    bc.postMessage({ type: 'increment', count: current })
    bc.close()
  } catch {}
  return current
}

function onCountChange(callback: (count: number) => void): () => void {
  // Listen for changes from other tabs via BroadcastChannel
  let bc: BroadcastChannel | null = null
  try {
    bc = new BroadcastChannel(CHANNEL_NAME)
    bc.onmessage = (event) => {
      if (
        event.data?.type === 'increment' &&
        typeof event.data.count === 'number'
      ) {
        callback(event.data.count)
      }
    }
  } catch {}

  // Also listen for storage events (fallback for browsers without BroadcastChannel)
  const handleStorage = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY && e.newValue) {
      const val = parseInt(e.newValue, 10)
      if (!isNaN(val)) callback(val)
    }
  }
  window.addEventListener('storage', handleStorage)

  return () => {
    try {
      bc?.close()
    } catch {}
    window.removeEventListener('storage', handleStorage)
  }
}

export { getCount, incrementCount, onCountChange }
